<div>
  <h2 *ngIf="!loginDisplay">You must login before being able to access and edit your contacts</h2>
</div>
